'use client'

import React from 'react'
import { IProduct } from '@/app/[locale]/_types'
import { HStack, Text } from '@chakra-ui/react'
import { Rating, RoundedStar } from '@smastrom/react-rating'
import Comment from '../Comments'

const CRating = ({ product }: { product?: IProduct }) => {
  return (
    <HStack justifyContent='space-between' pt={{ base: 0, lg: 2 }}>
      <HStack gap={3} alignItems={'center'} flex={1}>
        <Rating
          readOnly
          style={{ maxWidth: 100 }}
          value={product?.rating || 5}
          itemStyles={{
            itemShapes: RoundedStar,
            activeFillColor: 'var(--rate-color)',
            inactiveFillColor: 'var(--gray-color-400)',
          }}
        />
        <Text fontSize='sm' lineHeight={1}>
          {parseFloat(String(product?.rating || 5)).toFixed(1)}
        </Text>
      </HStack>
      <Comment id={product?.id} />
    </HStack>
  )
}

export default CRating
